import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import KogInputAutoCompleteCheckControlled from '@/main/components/shared/inputAutoCompleteCheck/inputAutoCompleteCheckControlled';
import { StatusRegisterEnum } from '@/main/services/enum/StatusRegisterEnum';
import { isNullUndefined } from '@/main/services/utils';
import { getBodyshops, resetReducerBodyshops, useBodyshopReducer } from '@/main/store/bodyshop';
import { GeneralVariableType, useDynamicFiltersExport } from './dynamicFiltersExport';
import { getQuoteStatus, useQuoteStatusReducer } from '@/main/store/quoteStatus';

interface IVariableTypeOrderStatusProps extends GeneralVariableType { }
function VariableTypeOrderStatus({
  filter
}: IVariableTypeOrderStatusProps) {
  const dispatch = useDispatch();
  const {
    keyReducer,
    findFieldIndexByGuidDynamicReportVariable,
    idScreen,
    watcherCountry
  } = useDynamicFiltersExport();
  const { quoteStatus: quoteStatusReducer } = useQuoteStatusReducer();
  const {
    control,
    resetField,
    setValue
  } = useFormContext();

  useEffect(() => {
    dispatch(getQuoteStatus());
  }, [])

  const disabledStatus = isNullUndefined(quoteStatusReducer.data) || quoteStatusReducer.data.length === 1
  const indexField = findFieldIndexByGuidDynamicReportVariable(filter.guidDynamicReportVariable);

  return (
    <>
      <KogInputAutoCompleteCheckControlled
        name={`filtersDinamics.${indexField}.value`}
        disableSelectAll
        control={control}
        options={quoteStatusReducer.data || []}
        label={filter.responseServer.filterName}
        disabled={disabledStatus}
        isLoading={quoteStatusReducer.isLoading}
        controllerProps={{ rules: { required: filter.responseServer.mandatory } }}
        customInputProps={{ required: filter.responseServer.mandatory, id: idScreen('select-status') }}
        onChangeCustom={(value, optionChanged, reason) => { }}
      />
    </>
  )
}

export default VariableTypeOrderStatus